import React, {useState, useEffect} from 'react';
import {FormControl,InputLabel,Select as MaterialSelect ,
  Box,Typography, TextField} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
//import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
//import Alert from '@material-ui/lab/Alert';
import {DatePicker, MuiPickersUtilsProvider, TimePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";
import ModalTam from '../Generales/ModalTam';
import {toast} from 'react-toastify';
import {llamadaApiToken,llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'noWrap',
    //alignItems: 'center',
    flexDirection:"column"
  },
  wrapper: {
    //margin: theme.spacing(0),
    margiTop: 0,
    paddingTop:0,
    position: 'relative',
  },
 
  buttonGuardar:{color: green[500],},
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function ModalNvo({modalAbierto,setModalAbierto,titulo,listStatus ,listTipo,actualizar, auxRegis}) {  
  let history = useHistory();
  const classes = useStyles();
  const idusu= localStorage.getItem('UsuId');
  const source = axios.CancelToken.source();   
  const [aviso, setAviso] = useState(false);  
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');    
  const [registro,setRegistro]= useState({ Usuario:'', Terminal:'', Descripcion:'', registro:0,
                                            TipoId:'', Status:"",   Maquinaria:"",
                                              refaccion:"", auxId:0, Proveedor:"", Domicilio:"", 
                                              UnidadTiempo:"", Tiempo:"", Importze:"", Impuesto:"", Poliza:""})          
  
  const [espera,setEspera]=useState(false);
  const [banderaFch, setBanderaFch]=useState(false);
  const [fechas,setFechas]=useState({inicio:new Date() ,final:new Date()});
  const [listUniTiempo, setListUniTiempo]=useState([]);
  const [listTiempo, setListTiempo]=useState([]);
  const [listBanco, setListBanco]=useState([]);
  const [listProveedor, setListProveedor]=useState([]);
  const [listProveedorDom, setListProveedorDom]=useState([]);
  const [listProveedorCuenta, setListProveedorCuenta]=useState([]);
  const {Descripcion, Maquinaria,   auxId, TipoId, Status,  refaccion, Proveedor, Domicilio, 
          UnidadTiempo, Tiempo, Importe, Impuesto, Poliza } = registro;
  const {inicio,final}=fechas  

  useEffect(()=>{
    getListUniTiempo()
    getListBanco()    
    getListProvedor()
    if (auxRegis && auxRegis.length !== 0 ) 
    {
      setRegistro({...registro, auxId: auxRegis.Id,  Descripcion:auxRegis.Nota, Poliza:auxRegis.Poliza,
        Domicilio:auxRegis.ProvDomId, Proveedor:auxRegis.ProvId, UnidadTiempo:auxRegis.UnidId,
        Tiempo:auxRegis.UnidCant,
        TipoId:auxRegis.TpId, Impuesto:auxRegis.Impuesto, Importe:auxRegis.Importe, Status:auxRegis.StId})
      setFechas({inicio:moment.utc(auxRegis.FIni).local(true)  ,final:auxRegis.FFin=== "1900-01-01T00:00:00.000Z"? new Date(): moment.utc(auxRegis.FFin).local(true)})
    }
    return () => {
      source.cancel();
    }

  },[])

  const guardarInicio = auxfecha =>
  {
    setFechas({...fechas, inicio: auxfecha })
  };

  const guardarFinal = auxfecha => {
    setBanderaFch(true)
    setFechas({...fechas, final: auxfecha})
  };

  const getListUniTiempo = () => {
    const data = qs.stringify({
      Usuario: idusu,
   
      idDispositivo: '89y7gttvjhj98h'
    });
    const url = "/renta/unidad-tiempo";

    function respuestaListTermin(aux) {
      if (aux[0].Id !== -1) {                
        setListUniTiempo(aux)
      }
    }

    llamaApiCargaToken(data, url, respuestaListTermin, ErrorGeneral, setEspera, history, source)
  };    
  
    const getListBanco = () => {
      const data = qs.stringify({
        Usuario:idusu,
        ip:"172.0.0.0",
        idDispositivo: '987gyubjhkkjh'
      });
      const url = "/renta/banco";
  
      function respuesta(aux) {
        if (aux[0].Id!==-1) 
        {                  
          setListBanco(aux);                                      
        }         
      }
      llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
    };   

    const getListProvedor = () => {
      const data = qs.stringify({
        Usuario:idusu,
        ip:"172.0.0.0",
        idDispositivo: '987gyubjhkkjh'
      });
      const url = "/renta/proveedor";
  
      function respuesta(aux) {
        if (aux[0].Id!==-1) 
        {                  
          setListProveedor(aux);                                      
        }         
      }
      llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
    };   

  const getListProveedorDom = (provee) => {
    const data = qs.stringify({
      Usuario:idusu,
      Proveedor:provee,
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/renta/proveedor/domicilio";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListProveedorDom(aux);                                      
      }         
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  };   

  const getListProveedorCuenta = (provee) => {
    const data = qs.stringify({
      Usuario:idusu,
      Proveedor:provee,
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/renta/proveedor/cuenta";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListProveedorCuenta(aux);                                      
      }         
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  };   

  const registrarNvo=()=>{
    const fini=moment(inicio).format("YYYY-MM-DD")      
    const fFin=moment(final).format("YYYY-MM-DD")   
    const data = qs.stringify({                            

        Usuario:idusu,
        Llave:auxId,
        Tipo:TipoId,
        Status:Status,
        Proveedor:Proveedor,
        Domicilio:Domicilio,
        UnidadTiempo:UnidadTiempo,
        Tiempo:Tiempo,
        FIni:`${fini}T00:00:00`,
        FFin:  `${fFin}T23:59:59` ,
        Importe:parseFloat(Importe),
        Impuesto:parseFloat(Impuesto),
        Poliza:Poliza,
        Nota:Descripcion,
        idDispositivo:'iu87ygubhjjij',
    });   
    const url = "/renta/new-edit";
    function respuesta(aux) {
      if (aux.respuesta === 1) 
      {   let mensaje="Se registro correctamente "
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)           
        //setRegistroExitoso(true) 
        toast.success(mensaje,{
          pauseOnFocusLoss: false,                    
          toastId: `nvo-cctv${aux.mensaje}`
        })
        actualizar()
        setModalAbierto(false)
      }       
    }    
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source); 
  }  

  const mostrarAlertas =(auxMensaje)=>{ 
    setTipoAdvertencia("warning")
    let mensaje=auxMensaje            
    setMensaje(mensaje);
    setAviso(true)   
  } 

  function valNulos(auxMensaje,auxCampo) 
  {    let valida=false    
    if ( auxCampo !== '' && auxCampo !== '0' && auxCampo !==0 
        && auxCampo !== null && auxCampo!==" " ) 
    {   valida=true              
    }
    if (!valida) 
    {   mostrarAlertas(auxMensaje)
    }
    return valida
  }

  function valBool(auxMensaje,auxCampo) 
  {    let valida=false    
    if ( auxCampo ) 
    {   valida=true              
    }
    if (!valida) 
    {   mostrarAlertas(auxMensaje)
    }
    return valida
  }

  const valMaq=()=>{
    let respuesta=false
    if ( ( TipoId !==2 &&TipoId !=="2" ) || ( ( TipoId ===2 || TipoId ==="2" ) && valNulos("Seleccionar Maquinaria",Maquinaria ) ) ) {
      respuesta=true
    }
    return respuesta
  }

  const valRefaccion=()=>{
    let respuesta=false
    if ( ( TipoId !==3 && TipoId !=="3" ) || ( ( TipoId ===3 || TipoId ==="3" ) && valNulos("Seleccionar Refacción",refaccion ) ) ) {
      respuesta=true
    }
    return respuesta
  }
  
  const valFchFin=()=>{
    let respuesta=false
    if ( ( Status !==2 && Status !=="2" ) || ( ( Status === 2 || Status ==="2" ) && valBool("Seleccionar Fecha Final",banderaFch ) ) ) {
      respuesta=true
    }
    return respuesta
  }

  const guardarParo = () => {
  
    if ( valNulos("Seleccionar Estatus",Status ) && valNulos("Seleccionar Tipo",TipoId ) && valFchFin()   ) 
    {         
      setAviso(false)                                                                                       
     registrarNvo()                                     
    }                           
  };
  
  const onChange = e =>
  {
    setRegistro({ ...registro, [e.target.name] : e.target.value })
  };

  const onChangeSelected = e =>
  {
    setRegistro({ ...registro, [e.target.name] : e.target.value })
  };

  const onChangeProveed = e =>
  {
    getListProveedorDom(e.target.value)
    setRegistro({ ...registro, [e.target.name] : e.target.value, proveedorDom: ""})
  };


  const onChangeRef = e =>
  { let expNopermitida = new RegExp('[$!?]');
    //let expMenos = new RegExp('-');
    //let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9#_:%-({})/*=|]');
    if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) ) 
        || e.target.value===' ' || e.target.value==='') 
    {    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const onChangeNum = e =>
  { let expNopermitida = new RegExp('[#A-Za-z_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[0-9]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {  
      setRegistro({
        ...registro,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };


  const fecha=() =>{
  return  <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>      
 
    <DatePicker disableFuture
      label="Fecha Inicio" size={"small"}  
      value={inicio} style={{width:7+'rem', marginRight:"1rem"}}
      onChange={guardarInicio}
      views={["year", "month", "date"]}  
      minDate="2017-03-14" maxDate={new Date()}
      format="dd/MM/yyyy"
      cancelLabel={"Cancelar"} okLabel="Seleccionar"       
    />
    <DatePicker  //disableFuture disabled={Status === 2 || Status === "2" ? false :true}
      id="final" format="dd/MM/yyyy"
      label="Fecha Final"
      views={["year", "month", "date"]}
      minDate={inicio} //maxDate={new Date()}
      value={final} name="final"
      size="small"
      style={{width: 7 + 'rem'}}
      onChange={guardarFinal}     
    />                  
  </MuiPickersUtilsProvider>
  }
  
  return (
    <ModalTam  titulo={titulo} modalAbierto={modalAbierto} 
      setModalAbierto={setModalAbierto} guardarDatos={guardarParo} 
      mensaje={mensaje} tipoAdvertencia={tipoAdvertencia} 
      aviso={aviso} setAviso={setAviso} espera={espera} 
      setEspera={setEspera} tamanio="md" btnDesact={false}
    >    
    <form className={classes.root} noValidate autoComplete="off" fullWidth>     
   
    <Box mb={1} display={"flex"} flexDirection={"row"}>
    
    { listStatus.length !== 0 ?
      <FormControl className={classes.formControl} size="small"  >
        <InputLabel htmlFor="age-native-simple">Estatus</InputLabel>
        <MaterialSelect
          native value={Status} onChange={onChange}
          inputProps={{ name: 'Status', id: 'Status',}}
        >
          <option aria-label="None" value="" />                     
          {listStatus.map((row,index) => (
            <option value={row.value} key={index} >{row.label}</option>
          ))}   
        </MaterialSelect>
      </FormControl>     
    :null }       
    { listTipo.length !== 0 ?
      <FormControl className={classes.formControl} size="small" style={{marginLeft:1+'rem'}} >
        <InputLabel htmlFor="age-native-simple">Tipo</InputLabel>
        <MaterialSelect
          native value={TipoId} onChange={onChange}
          inputProps={{ name: 'TipoId', id: 'TipoId',}}
        >
          <option aria-label="None" value="" />                     
          {listTipo.map((row,index) => (
            <option value={row.value} key={index} >{row.label}</option>
          ))}   
        </MaterialSelect>
      </FormControl>     
    :null  }   
      <Box style={{width:9+'rem'}} mt={1} ml={1}>      
      <FormControl component="fieldset" style={{width:9+'rem'}}>    
        <TextField id="outlinedCantidad" variant='outlined'           
          label="Folio"  size="small"
          value={Poliza} onChange={onChange}  
          name="Poliza" fullWidth
        /> 
      </FormControl>
    </Box>   
    </Box>  
    <Box style={{marginTop:".5rem", marginBottom:".5rem"}}>
      {fecha()}
    </Box>    
            
    { /*  listUniTiempo.length !== 0 ?
      <FormControl className={classes.formControl} size="small" style={{ width:"10rem"}} >
        <InputLabel htmlFor="age-native-simple">Maquinaria</InputLabel>
        <MaterialSelect disabled={TipoId === 1 || TipoId === "1"? true : false}
          native value={Maquinaria} onChange={onChange}
          inputProps={{ name: 'Maquinaria', id: 'Maquinaria',}}
        >
          <option aria-label="None" value="" />                     
          {listUniTiempo.map((row,index) => (
            <option value={row.Id} key={index} >{row.NoEco}</option>
          ))}   
        </MaterialSelect>
      </FormControl>     
    :null  */}     
    <Box display={"flex"} flexDirection={"column"}>
      {  listProveedor.length !== 0 ?
        <FormControl className={classes.formControl} size="small" fullWidth style={{   marginRight:"1rem"}} >
          <InputLabel htmlFor="age-native-simple">Proveedor</InputLabel>
          <MaterialSelect 
            native value={Proveedor} onChange={onChangeProveed}
            inputProps={{ name: 'Proveedor', id: 'Proveedor',}}
          >
            <option aria-label="None" value="" />                     
            {listProveedor.map((row,index) => (
              <option value={row.Id} key={index} >{row.Alias}</option>
            ))}   
          </MaterialSelect>
        </FormControl>     
      :null }  
      
      
      {  listProveedorDom.length !== 0 ?
        <FormControl className={classes.formControl} size="small" style={{  }}  fullWidth>
          <InputLabel htmlFor="age-native-simple">Proveedor Domicilio</InputLabel>
          <MaterialSelect 
            native value={Domicilio} onChange={onChange}
            inputProps={{ name: 'Domicilio', id: 'Domicilio',}}
          >
            <option aria-label="None" value="" />                     
            {listProveedorDom.map((row,index) => (
              <option value={row.Id} key={index} >{row.Alias}</option>
            ))}   
          </MaterialSelect>
        </FormControl>     
      :null }  
    </Box>
 
 
    <Box display={"flex"} width={"100%"} >
    { listUniTiempo.length !== 0 ?
       
         <FormControl className={classes.formControl} size="small" style={{ width:"9rem", marginRight:"1rem"}} >
          <InputLabel htmlFor="age-native-simple">Unidad Tiempo</InputLabel>
          <MaterialSelect 
            native value={UnidadTiempo} onChange={onChangeSelected}
            inputProps={{ name: 'UnidadTiempo', id: 'Descr',}}
          >
            <option aria-label="None" value="" />                     
            {listUniTiempo.map((row,index) => (
              <option value={row.Id} key={index} >{row.Descr}</option>
            ))}   
          </MaterialSelect>
        </FormControl>     
       
      :null }  
      <Box display="flex" style={{width:10+'rem',marginRight:".5rem"}} mt={2}>      
        <FormControl component="fieldset" style={{width:10+'rem'}}>    
          <TextField id="outlinedCantidad" variant='outlined'           
            label="Tiempo"  size="small"
            value={Tiempo} onChange={onChangeNum}  
            name="Tiempo" fullWidth
          /> 
        </FormControl>
      </Box> 
    </Box>
    <Box display={"flex"}>
      <Box style={{width:10+'rem',marginRight:".5rem"}} mt={2}>      
        <FormControl component="fieldset" style={{width:10+'rem'}}>    
          <TextField id="outlinedCantidad" variant='outlined'           
            label="Importe"  size="small"
            value={Importe} onChange={onChangeNum}  
            name="Importe" fullWidth
          /> 
        </FormControl>
      </Box>           
      <Box style={{width:10+'rem'}} mt={2}>      
      <FormControl component="fieldset" style={{width:10+'rem'}}>    
        <TextField id="outlinedCantidad" variant='outlined'           
          label="Impuesto"  size="small"
          value={Impuesto} onChange={onChangeNum}  
          name="Impuesto" fullWidth
        /> 
      </FormControl>
    </Box>           
    </Box>           
{/*     <Box>
      <Typography component="p" variant="body2" color='primary' 
        style={{margin:0,marginLeft:.5+'rem'}} 
      >
        Titulo
      </Typography>   
      <textarea id="Titulo-input" name="Titulo" rows="3" placeholder="Titulo"
        cols="100" style={{width: 24+"rem",borderRadius:3+'px'}} 
        value={Titulo} onChange={onChange} maxlength={500}
      />
    </Box> */}
  
    <Box>
      <Typography component="p" variant="body2" color='primary' 
        style={{margin:0,marginLeft:.5+'rem', marginTop:".2rem"}} >
          Notas
      </Typography>   
      <textarea id="descripcion-input" name="Descripcion" rows="5"
        cols="100" placeholder="Notas" style={{width: 24+"rem",borderRadius:3+'px'}} 
        value={Descripcion} onChange={onChange} maxlength={500}
      />
    </Box>
  </form>
  </ModalTam>
  );
}
